var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppPill',{class:("component-proposal-status-id " + _vm.btnColour)},[_vm._v(_vm._s(_vm.proposalStatusText))])}
var staticRenderFns = []

export { render, staticRenderFns }